import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-course-rating',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-rating.component.html',
  styleUrl: './course-rating.component.scss',
})
export class CourseRatingComponent {
  userRating = input<number>(0);
  /** When true, rating is disabled (e.g. course not joined or not completed) */
  disabled = input<boolean>(false);
  onRateCourse = output<number>();
  ratingScale = [1, 2, 3, 4, 5];

  hoveredIndex: number | null = null;

  get isVoted(): boolean {
    return this.userRating() > 0;
  }

  get canRate(): boolean {
    return !this.disabled() && !this.isVoted;
  }

  setHovered(index: number | null): void {
    if (this.canRate) {
      this.hoveredIndex = index;
    }
  }

  rateCourse(rating: number): void {
    if (this.canRate) {
      this.onRateCourse.emit(rating);
    }
  }

  isRatingActive(rating: number, index: number): boolean {
    if (this.isVoted) {
      return rating <= this.userRating();
    }
    return this.hoveredIndex !== null && index <= this.hoveredIndex;
  }
}
